var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Media Icon Square/Instagram"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Social Media Icon",
    x: 0.540039,
    width: 34.92,
    height: 34.9199,
    rx: 7.75999,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Instagram",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26953 17.4604C9.26953 13.9732 9.26953 12.2295 10.1005 10.9736C10.4716 10.4128 10.9519 9.93253 11.5127 9.56146C12.7686 8.73047 14.5122 8.73047 17.9995 8.73047C21.4868 8.73047 23.2304 8.73047 24.4863 9.56146C25.0472 9.93253 25.5274 10.4128 25.8985 10.9736C26.7295 12.2295 26.7295 13.9732 26.7295 17.4604C26.7295 20.9477 26.7295 22.6914 25.8985 23.9473C25.5274 24.5081 25.0472 24.9884 24.4863 25.3594C23.2304 26.1904 21.4868 26.1904 17.9995 26.1904C14.5122 26.1904 12.7686 26.1904 11.5127 25.3594C10.9519 24.9884 10.4716 24.5081 10.1005 23.9473C9.26953 22.6914 9.26953 20.9477 9.26953 17.4604ZM22.5193 17.4605C22.5193 19.9566 20.4958 21.9801 17.9997 21.9801C15.5036 21.9801 13.4801 19.9566 13.4801 17.4605C13.4801 14.9644 15.5036 12.9409 17.9997 12.9409C20.4958 12.9409 22.5193 14.9644 22.5193 17.4605ZM17.9997 20.451C19.6513 20.451 20.9902 19.1121 20.9902 17.4605C20.9902 15.8089 19.6513 14.47 17.9997 14.47C16.3481 14.47 15.0092 15.8089 15.0092 17.4605C15.0092 19.1121 16.3481 20.451 17.9997 20.451ZM22.6978 13.7758C23.2844 13.7758 23.7598 13.3003 23.7598 12.7138C23.7598 12.1273 23.2844 11.6518 22.6978 11.6518C22.1113 11.6518 21.6359 12.1273 21.6359 12.7138C21.6359 13.3003 22.1113 13.7758 22.6978 13.7758Z",
    fill: "#141619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.6efe318cf5acee7c540daa77e44d8ef0.svg";
export { ForwardRef as ReactComponent };